<template>
    <div>
        <el-descriptions class="margin-top" title="" direction="vertical" :column="3" border>
        <el-descriptions-item :span="2"> 
          <template slot="label">活动名称 </template> {{ rowObj.name }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">自查频率 </template> {{ $until.easyArrToObj($store.state.frequencys)[rowObj.frequency] }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">自查开始日期 </template> {{ rowObj.start_time }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">自查结束日期 </template> {{ rowObj.end_time }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">检查对象</template> {{ rowObj.target_name }}
        </el-descriptions-item>
        <el-descriptions-item :span="3">
          <template slot="label">活动描述 </template> {{ rowObj.desc ? rowObj.desc : '无' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">检查人员 </template> {{ rowObj.member_name }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">上报人员 </template> {{ rowObj.submit_name }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">上报时间 </template> {{ rowObj.submit_time }}
        </el-descriptions-item>
      </el-descriptions>
      <template v-if="rowObj.reports && rowObj.reports.length > 0">
        <p style="font-size: 16px;font-weight: 700;color:#111;margin-top:32px;margin-bottom:20px;padding:0 12px;">检查结果</p>
        <el-descriptions class="margin-top" title="" style="margin-bottom:16px;" 
           :column="1" border>
          <el-descriptions-item  v-for="(item, index) in rowObj.reports" :key="index">
            <template slot="label">{{ item.standard_name }} </template> {{  $until.easyArrToObj($store.state.zxjczt)[item.standard_res] }}
          </el-descriptions-item>
        </el-descriptions>
      </template>
    </div>
</template>
<script>
export default {
    props: ['rowObj'],
    data() {
        return {
          
        };
    },
    mounted() {
      // console.log(this.$until.easyArrToObj(this.$store.state.zxjczt));
    },
    methods: {
    },
};
</script>
